
import Component, { ComponentMethods } from "@/module/component/component"

import Package from "@/../package.json"
import Request from "@/module/request/request"

import elemIcon from "@/components/elem-icon.vue"
import compMenu from "@/components/comp-menu.vue"
import compFormSmall from "@/components/comp-form-small.vue"
import Message from "@/module/interactive/message"

class InitialPage extends ComponentMethods implements ComponentEntity {
    components = {
        elemIcon,
        compMenu,
        compFormSmall,
    }

    public step: number = 0

    data() {
        return {
            display: false,
            show: false,
            version: Package.version,
            structure: null,
            initials: null,
        }
    }

    watch = {}

    mounted() {
        this.getInitialConfig()
    }

    public getInitialConfig() {
        Request.get<obj>("ADMIN://Setting/Config/GetInitialConfigs").then(res => {
            this.initials = res
        })
    }

    /**
     * 关闭
     */
    onCloseStep() {
        Message.info("是否确认关闭设置向导？（可稍后自行设置）", true)
            .onConfirm(() => {
                Request.post("ADMIN://Setting/Config/SetInitialStatus").then(() => {
                    this.$emit("on-success", {
                        tag: "Initial",
                    })
                })
            })
            .build()
    }

    /**
     * 下一步
     */
    public async onNextStep() {
        const item = this.initials[this.step]
        // 获取当前表单
        const form = this.$refs[item.name][0]
        // 获取表单数据
        const data = await form.getFormData()
        // 缓存表单数据
        item.formData = data
        // 最后一步提交
        if (this.step === this.initials.length - 1) {
            // 提交
            Request.post("ADMIN://Setting/Config/Initial", {
                data: this.initials.map((item: obj) => {
                    return {
                        name: item.name,
                        value: item.formData,
                    }
                })
            }, {
                json: true
            }).then(() => {
                this.$emit("on-success", {
                    tag: "Initial",
                })
            })
        } else {
            this.step++
        }
    }

    /**
     * 上一步
     */
    public onBackStep() {
        if (this.step > 0) this.step--
    }
}

export default Component.build(new InitialPage())
